const mapStateToProps = state => ({
  forgotPasswordStatus: state.account.forgotPasswordStatus
})

export default mapStateToProps
